import React from 'react';
import PropTypes from 'prop-types';
import { MessageDescriptorPropType } from '../../prop-types/intl';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import style from './add-to-batch-dropdown.module.less';

export const BatchDropdownItem = ({ fulfillmentPlanSetId, onClick, name, shipmentCount, title, disabled = false, className }) => (
  <DropdownMenuItem key={fulfillmentPlanSetId} className={className} disabled={disabled} onClick={onClick} title={title}>
    <div className={style['batch-row']}>
      <div className={style['batch-name']}>{name}</div>
      <div className={style['shipment-count']}>{shipmentCount}</div>
    </div>
  </DropdownMenuItem>
);

BatchDropdownItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  fulfillmentPlanSetId: PropTypes.string.isRequired,
  name: PropTypes.oneOfType([PropTypes.string, MessageDescriptorPropType]).isRequired,
  shipmentCount: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
